import initialState from "./initialState"
import { SET_APP_CONFIG, SET_MIGRATION_STATUS } from '../constants/AppActionType'

export default function AppReducer(state = initialState.app, action) {
    let newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {
        case SET_APP_CONFIG:
            newState = { ...newState, ...action.value }
            return newState

        case SET_MIGRATION_STATUS:
            newState.migrationStatus = action.value
            return newState

        default: return state;
    }
}
